const player = {
    namespaced: true,
    actions: {
        shuffleNow({ dispatch, rootState }, payload = {}) {
            const tracks = Array.isArray(payload) ? payload : (payload.tracks || [])
            if (!tracks.length) {
                return false
            }
            const shuffleEnabled = !!rootState.common?.shuffle
            const index = shuffleEnabled ? null : Math.floor(Math.random() * tracks.length)
            return dispatch('playTrackList', {
                tracks,
                index,
            }, { root: true })
        },
        setNextInQueue({ commit }, tracks = []) {
            if (!Array.isArray(tracks) || !tracks.length) {
                return false
            }
            commit('setNextInQueue', tracks, { root: true })
            return true
        },
        addToQueue({ commit }, tracks = []) {
            if (!Array.isArray(tracks) || !tracks.length) {
                return false
            }
            commit('addToQueue', tracks, { root: true })
            return true
        }
    }
}

export default player
